import React from "react";
import Slider from "react-slick";
import TeamStyle3 from "../Team/TeamStyle3";
import styled from "styled-components";
import { defaultCurrency, imageBaseUrl } from "../../constants/ApiConstants";
import { Link } from "react-router-dom";
import DoctorFilterComponent from "../DoctorFilterComponent";
import { useSelector } from "react-redux";
import FullPageLoader from "../FullPageLoader";
import Spinner from "../Spinner";
import { FaStar } from "react-icons/fa6";
import ListEmptyText from "../ListEmptyText";

export default function TeamSlider({ loading, filters, data, onFilterChanged }) {
  const { settings } = useSelector((state) => state.appSlice);
  const { currency } = settings;

  return (
    <PageContainer>
      <DoctorFilterComponent initialFilters={filters} onFilterChanged={onFilterChanged} />
      {loading && <Spinner />}
      {!loading && data.length == 0 && <ListEmptyText text={"No doctor found."} />}
      {!loading && data.length > 0 && (
        <DoctorListWrapper>
          {data.map((doctor) => (
            <Link to={`/doctors/${doctor.id}`} key={doctor.id} href="#" className="doctor_item">
              <img className="doctor_image rounded" src={`${imageBaseUrl}${doctor.image}`} />
              <div className="doctor_details">
                <div className="d-flex justify-content-between align-items center">
                  <strong className="doctor_name">{doctor.name}</strong>
                  <div className="rating-badge d-flex align-items-center">
                    <span className="fs-md" style={{ color: "orange" }}>
                      {parseFloat(doctor.rating)}
                    </span>
                    <FaStar size={14} color="orange" />
                  </div>
                </div>

                <span className="doctor__specialist">{doctor.designation}</span>
                <span className="doctor__exp">{`Exp: ${doctor.experience_year} Fees: ${currency}${doctor.consultation_fee}`}</span>
              </div>
            </Link>
          ))}
          {/* <LoadMore></LoadMore> */}
        </DoctorListWrapper>
      )}
    </PageContainer>
  );
}
// background: linear-gradient(to bottom, #4f81bd, #a7c9e6);

const PageContainer = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  margin-top: 4rem;
  column-gap: 2rem;
  border: 1px solid #eeeeee;
  column-gap: 1rem;
  margin-top: 1rem;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    border: 0;
  }
`;
const DoctorListWrapper = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  max-width: 100%;
  column-gap: 1rem;
  margin-top: 1rem;

  .doctor_item {
    display: flex;
    flex-direction: row;
    gap: 1rem;
    align-items: center;
    background-color: #fcfcfc;
    border-radius: 12px;
    margin-bottom: 12px;
    padding: 16px 24px;
    height: 130px;
    transition: all ease-in-out 0.3s;
    border: 1px solid #eeeeee;
    @media screen and (max-width: 768px) {
      margin: 0;
      padding: 0;
      margin: 12px;
      border: none;
      margin-bottom: 1rem;
    }

    &:hover {
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      .doctor_image {
        object-fit: cover;
        scale: 1.05;
      }
    }
  }

  .rating-badge {
    background-color: #ffe6b8;
    padding-left: 0.6rem;
    padding-right: 0.6rem;
    gap: 0.3rem;
    border-radius: 20px;
  }
  .doctor_image {
    max-width: 100%;
    height: 6rem;
    width: 6rem;
    object-fit: contain;
    border-radius: 6px;
    transition: all ease-in-out 0.3s;
  }
  .doctor_details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;
  }
  .doctor_name {
    color: #000;
  }
  .doctor__specialist {
    color: #40bcff;
    font-weight: 500;
    font-size: 0.95rem;
  }
  .doctor__exp {
    font-size: 0.95rem;
    font-weight: 500;
  }
  @media (min-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    height: 100%;
    align-items: start;
    height: 1px;
  }
  /* @media (min-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  } */
`;
